export default __webpack_public_path__ + "static/media/1.ccfc7ae7.png";